import WorkRampAdminAppOptions from '~/navigation/admin-app-options';
import AppNavigation from '~/navigation/app-navigation';

const Permission = APP_CONSTANTS.PERMISSIONS;

const WorkRampApps = {
  OPTIONS: {
    ADMIN: {
      id: 0,
      getColor() {
        return '#203A8E';
      },
      src: '/images/vertnav_admin_icon.svg',
      hrefFnc: (academyId) => (academyId ? `/admin/academies/${academyId}/theming` : '/'),
      showShadow(menu) {
        return !(menu && menu.id && menu.id === WorkRampAdminAppOptions.REPORTING.id);
      },
      width: '18px',
      height: '18px',
      shouldShow: (currentUser) =>
        currentUser.admin ||
        currentUser.is_editor ||
        currentUser.isAcademyAdmin ||
        currentUser.rolePermissionNames?.some((permission) =>
          [
            Permission.REPORTING,
            Permission.GROUPS_MANAGEMENT,
            Permission.USERS_MANAGEMENT,
            Permission.WORKFLOWS_MANAGEMENT,
            Permission.BADGES_MANAGEMENT,
            Permission.CMS_MANAGEMENT,
          ].includes(permission),
        ),
      sortOrder: 1,
      isAdminOption: true,
    },
    TRAINING: {
      id: 2,
      getColor() {
        return '#2196F3';
      },
      src: '/images/vertnav_training_icon.svg',
      href: '/guides',
      showShadow() {
        return true;
      },
      getTitle() {
        return 'Training';
      },
      width: '17px',
      height: '17px',
      sortOrder: 3,
      shouldShow: (_currentUser) => true,
    },
    ANALYTICS: {
      id: 4,
      getColor() {
        return '#006F94';
      },
      src: '/images/vertnav_analytics_icon.svg',
      href: '/analytics',
      getTitle() {
        return 'Analytics';
      },
      width: '16px',
      height: '18px',
      sortOrder: 5,
      shouldShow: (_currentUser) => true,
    },
    GENERAL: {
      id: 5,
      getColor() {
        return '#66707C';
      },
      getTitle() {
        return 'General';
      },
      sortOrder: 6,
      shouldShow: (_currentUser) => true,
    },
  },

  getCurrentApp(appCode, currentUser, academyId, customerLearningCloudHubId) {
    if (appCode != null) {
      return new AppNavigation(appCode, currentUser, academyId, customerLearningCloudHubId);
    }
    return null;
  },

  getAllApps() {
    return Object.values(this.OPTIONS).sort((a, b) => a.sortOrder - b.sortOrder);
  },

  getAdminApps(currentUser) {
    return this.getAllApps().filter((option) => option.isAdminOption && option.shouldShow(currentUser));
  },

  getAppByCode(id) {
    const apps = this.getAllApps();

    return apps.find((app) => app.id === id) || this.OPTIONS.GENERAL;
  },

  isAdminPage(code) {
    return code === this.OPTIONS.ADMIN.id;
  },

  isTrainingPage(code) {
    return code === this.OPTIONS.TRAINING.id;
  },
};

export default WorkRampApps;
